<h4>
	<ng-content select="[title]"></ng-content>
</h4>

<span class="vlaio-value-tile-content">
	<ng-content select="[content]"> </ng-content>
</span>
